import { DefaultSidebar } from "@/core";

import "./AppSidebar.scss";

export const AppSidebar = () => {
  return <DefaultSidebar />;
};
